<template>
    <div>
        <page-header :title="$t('privateProfile.blockedUsers')" />
        <ion-item class="interactions-wrapper" lines="none">
            <ion-text class="ion-float-start interactions">
                {{ $t('privateProfile.blockedUsersText') }}
                {{ madeBlocksCount }}
            </ion-text>
        </ion-item>
        <ion-grid class="user-cards">
            <ion-row>
                <ion-col v-for="blocked in madeBlocks" :key="blocked.id" size-xs="6" size-sm="6" size-md="4" size-xl="3">
                    <user-card :user="blocked.blocked_user" />
                </ion-col>
                <ion-infinite-scroll v-if="isMobile" @ionInfinite="loadMore" threshold="100px" position="bottom">
                    <ion-infinite-scroll-content></ion-infinite-scroll-content>
                </ion-infinite-scroll>
                <ion-button
                    class="more-button"
                    v-if="(!isMobile || windowWidth >= 1200) && moreUsers"
                    @click="loadMoreBlocks"
                    shape="round"
                >
                    {{ $t('master.more') }}
                </ion-button>
            </ion-row>
        </ion-grid>
    </div>
</template>

<script>
import AxiosController from '@/controllers/AxiosController'
import PageHeader from '@/components/PageHeader'
import UserCard from '@/components/UserCard'
import isMobile from 'mobile-device-detect'

export default {
    name: 'BlockedUsers',
    components: { PageHeader, UserCard },
    data() {
        return {
            madeBlocks: [],
            madeBlocksCount: 0,
            currentPage: 1,
            lastPage: 0,
            moreUsers: false
        }
    },
    mounted() {
        AxiosController.get('/get-blocked-users').then(res => {
            const { blockedUsers } = res.data
            this.madeBlocks = blockedUsers.data
            this.madeBlocksCount = blockedUsers.total
            this.lastPage = blockedUsers.last_page
            if (this.lastPage > 1) {
                this.moreUsers = true
            }
        })
    },
    methods: {
        loadMore(event) {
            if (this.currentPage >= this.lastPage) {
                event.target.complete()
                return
            }
            this.loadMoreBlocks()
            event.target.complete()
        },
        loadMoreBlocks: function() {
            this.currentPage = this.currentPage + 1
            const params = {
                page: this.currentPage
            }
            AxiosController.get('/get-blocked-users', { params }).then(res => {
                const { last_page, data } = res.data.blockedUsers
                this.lastPage = last_page
                this.madeBlocks.push(...data)
                if (this.currentPage >= this.lastPage) {
                    this.moreUsers = false
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.more-button {
    margin: 20px auto;
}
</style>
